import React, { useState } from 'react';
import RunRequirementsView from './source-health/RunRequirementsView';
import '../bz/runHealth.css';

// Prevent -> Run requirements (/prevent/run-requirements): the Run requirements
// view of Platform -> Source Health as a page of its own, linked from the
// Prevent nav under Vendors. Same view, same API; this page adds only the head.
const RunRequirementsPage = () => {
  const [reloadToken, setReloadToken] = useState(0);
  return (
    // Routed outside PageContent (Layout.js "new design pages"), so it pads itself.
    <div
      style={{
        padding: '24px 32px',
        maxWidth: 1320,
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 24
      }}
    >
      <div className="bz-section-head" style={{ marginBottom: 0, flexWrap: 'wrap' }}>
        <div>
          <div className="bz-kicker" style={{ color: 'var(--prevent)' }}>
            Prevent · Vendors
          </div>
          <h1 className="bz-h1" style={{ marginTop: 4 }}>
            Run requirements
          </h1>
          <div className="bz-muted" style={{ fontSize: 'var(--fs-md)', marginTop: 4 }}>
            What each vendor&apos;s bug run needs, checked at the start of every run.
          </div>
        </div>
        <button type="button" className="bz-btn bz-btn--sm" onClick={() => setReloadToken(t => t + 1)}>
          Refresh
        </button>
      </div>
      <RunRequirementsView reloadToken={reloadToken} />
    </div>
  );
};

export default RunRequirementsPage;
